import axios from 'axios'

export default {
  addToCart (data) {
    return axios.post('/api/cart/update', { productCodeId: data.productCodeId, quantity: data.quantity })
      .then(response => response.data)
  },
  getTransporterData (data) {
    return axios.post('/api/transporters/getAvailableTransporters', {
      country: data.country,
      county: data.county,
      postal: data.postal,
      totalWithVat: data.totalWithVat,
      weight: data.weight
    })
      .then(response => response.data)
  },
  checkCoupon (data) {
    return axios.post('/order/preview_coupon', { coupon: data }).then(response => response.data)
  },
  validateVat (data) {
    return axios.post('/order/validateVat', { country: data.country, vat: data.vat }).then(response => response.data)
  }
}
